import { isAnyOf } from "@reduxjs/toolkit";
import { startAppListening } from "../../listener";
import { resourceActions } from "./slice";
import { PluginContextType } from "../plugin/types";
import { saveResource } from './actions';
import { accountStateSelector } from '../account/api';

export const autoSaveResources = (pluginContext: PluginContextType) => {
  return startAppListening({
    matcher: isAnyOf(
      saveResource,
      resourceActions.deleteResource,
      resourceActions.bulkImport
    ),
    effect: (_, api) => {
      const state = api.getState();
      const accountState = accountStateSelector(state);

      if (accountState.data?.id) {
        const resources = state.resources;
        if (Object.values(resources).length > 0) {
          pluginContext.saveResources(accountState.data.id, resources);
        }
      }
    }
  });
};
